import { render, staticRenderFns } from "./CashierLogs.vue?vue&type=template&id=4b1cdf0b&scoped=true"
import script from "./CashierLogs.vue?vue&type=script&lang=js"
export * from "./CashierLogs.vue?vue&type=script&lang=js"
import style0 from "./CashierLogs.vue?vue&type=style&index=0&id=4b1cdf0b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1cdf0b",
  null
  
)

export default component.exports